module.exports = __webpack_public_path__ + "static/media/default-topic.14699b26.png";